import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDataLayerValue } from '../../DataLayer';
import DetailPlayingMobile from '../Item/DetailPlayingMobile';
import Loading from './Loading';

function Song(props) {
    let { id } = useParams();
    const [{ song_playing }] = useDataLayerValue();
    const [idSong, setIdSong] = useState(id);
    const [loadingPage, setLoadingPage] = useState(true);
    const handleSetLoadingPage = (status) => {
        setLoadingPage(status)
    };
    useEffect(() => {
        if (idSong && idSong !== song_playing.id) {
            song_playing.id !== idSong ? setIdSong(song_playing.id) : setIdSong(id);
        }
    }, [id, song_playing]);


    return (
        <div className="Root__right-container__section--wrap-page is-detail-playing-mobile">
            <DetailPlayingMobile id={idSong} handleSetLoadingPage={handleSetLoadingPage} />
            <Loading loadingPage={loadingPage} />
        </div>
    );
}

export default Song;